<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Cierre de visita" class="mb-4"/>
		<title-bar v-if="school" :title="school.name" class="mb-4"/>
		<div class="col inner" v-if="synthesis" >
			<div style="width: 100%;">
				<div class="mb-4">
					<p>
						<template v-if="synthesis.data.visit">
							<strong>{{`Visita ${synthesis.data.visit}`}} </strong> -
						</template>
						{{`Realizado el ${getHumanDateAndTime(synthesis.date)}`}}
					</p>
				</div>

				<div class="mb-4">
					<h2>Coach</h2>
					<p>{{getPersonFullName(synthesis.coach)}}</p>
				</div>

				<div class="mb-4" v-if="!school">
					<h2>Colegio</h2>
					<p>{{synthesis.school.name}}</p>
				</div>

				<div class="mb-4" v-if="synthesis.data && synthesis.data.implementationLevel">
					<h2>Nivel de implementación </h2>
					<p>
						{{synthesis.data.implementationLevelText}}
					</p>
				</div>

				<div class="mb-4">
					<h2>Especificaciones </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.specifications">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="specifications" v-model="synthesis.data.specifications" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Niveles </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.academicLevels">
						<tr v-for="(item, index) in synthesis.data.academicLevels" v-if="item" :key="`levels${index}`">
							<td><p class="text-justify">{{item.name}}</p></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Idiomas </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.languages">
						<tr v-for="(item, index) in synthesis.data.languages" v-if="item" :key="`languages${index}`">
							<td><p class="text-justify">{{item.name}}</p></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Comentario general </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.description">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="description" v-model="synthesis.data.description" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Áreas de mejora </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.feedback">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="feedback" v-model="synthesis.data.feedback" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Fortalezas </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.strengths">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="strengths" v-model="synthesis.data.strengths" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>

				<div class="mb-4">
					<h2>Puntos importantes </h2>
					<table class="table table-sm table-striped" v-if="synthesis.data.observations">
						<tr>
							<td><b-form-textarea class="text-justify" style="background-color: white;" :rows="3" type="text" name="observations" v-model="synthesis.data.observations" :disabled="true"/></td>
						</tr>
					</table>
					<p v-else>
						Sin registro
					</p>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['synthesisId', 'schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		synthesis () {
			if (!this.$store.state.admin.synthesis) return null;
			let synthesis = this.$store.state.admin.synthesis;
			let type = typeof synthesis.data;
			if (type !== 'object') synthesis.data = JSON.parse(synthesis.data);
			if (synthesis.data.implementationLevel) {
				let implementationLevel = this.getImplementationLevel(synthesis.data.implementationLevel);
				synthesis.data.implementationLevelText = implementationLevel.text;
			}
			return synthesis;
		},
		school () {
			if (!this.$store.state.admin.schools) return null;
			if (!this.schoolId) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		},
		implemetationLevelsDropdown () {
			return this.$store.getters.implemetationLevelsDropdown;
		}
	},
	methods: {
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		getImplementationLevel (level) {
			return this.implemetationLevelsDropdown.find((item) => (item.value == level));
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/VisitClosureDetail.vue